<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.accounts.retrieveLoader">
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Equipo de {{account.name}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-1" @click="dialogCreate=true" outlined color="secondary">Invitar personas</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Tipo de cuenta</th>
                  <th class="text-left">Estado</th>
                  <th class="text-right">Activo desde</th>
                  <th class="text-right"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, i) in membersList" :key="i" :disabled="!d.is_active">
                  <td class="py-2">
                    <span class="d-block body-2 text--secondary font-weight-medium">{{d.first_name}} {{d.last_name}}</span>
                    <span>{{d.email}}</span>
                  </td>
                  <td>
                    <span v-if="!d.is_active">--</span>
                    <v-chip v-else-if="d.is_owner" color="lightBlue" text-color="primary" small>Dueño del espacio</v-chip>
                    <template v-else>
                      <v-chip v-if="d.is_admin" color="lightBlue" text-color="primary" small>Administrador</v-chip>
                      <v-chip v-else color="defaultGrey" text-color="secondary" small>Miembro</v-chip>
                    </template>
                  </td>
                  <td>{{d.is_active ? 'Activo' : 'Desactivado'}}</td>
                  <td class="text-right">{{d.created | dateTime}}</td>
                  <td class="text-right">
                    <v-menu v-if="!d.is_owner" offset-y left transition="scale-transition" min-width="160px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" retain-focus-on-click outlined color="secondary">•••</v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="patchMember(i)">
                          <v-list-item-title >{{d.is_admin ? 'Cambiar a miembro' : 'Cambiar a administrador'}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteMember(i)" v-if="d.is_active">
                          <v-list-item-title >Desactivar usuario</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteMember(i)" v-else>
                          <v-list-item-title >Activar usuario</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card class="mt-5" v-if="invitationsList.length">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Invitaciones pendientes</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-1" @click="dialogCreate=true" outlined color="secondary">Invitar personas</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th class="text-right">Enviado el</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, i) in invitationsList" :key="i">
                  <td>
                    <span class="d-block body-2 text--secondary font-weight-medium">{{d.email}}</span>
                    <span>{{d.name}}</span>
                  </td>
                  <td class="text-right">{{d.sent | dateTime}}</td>
                  <td class="text-right">
                    <v-menu v-if="!d.is_owner" offset-y left transition="scale-transition" min-width="160px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" retain-focus-on-click outlined color="secondary">•••</v-btn>
                      </template>
                      <v-btn class="d-block" @click="deleteInvitation(i)" height="34" width="160" text small retain-focus-on-click color="red" v-ripple="false">Cancelar invitación</v-btn>
                    </v-menu>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog invitations -->
    <v-dialog v-model="dialogCreate" width="700" persistent no-click-animation>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Invitar personas a {{account.name}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="dialogCreate=false" icon small retain-focus-on-click><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-col cols="12">
            <v-list class="transparent">
              <v-list-item>
                <v-col cols="12">
                  <v-list-item-subtitle class="py-1">
                    <v-row no-gutters>
                      <v-col class="py-0" cols="6">
                        <span class="body-2 text--secondary font-weight-medium">Email</span>
                      </v-col>
                      <v-col class="py-0" cols="4">
                        <span class="body-2 text--secondary font-weight-medium">Nombre</span>
                      </v-col>
                    </v-row>
                    <v-row v-for="(d, i) in invitations" :key="i" no-gutters>
                      <v-col class="py-1 pr-2" cols="6">
                        <v-text-field v-model.trim="$v.invitations.$each[i].email.$model" :error="$v.invitations.$each[i].email.$error" hide-details placeholder="nombre@ejemplo.com" maxlength="254" background-color="white" outlined required single-line dense />
                        <span class="d-block red--text caption py-1" v-if="!$v.invitations.$each[i].email.isUser">Ya es miembro de la cuenta</span>
                        <span class="d-block red--text caption py-1" v-if="!$v.invitations.$each[i].email.isInvited">Tiene una invitación pendiente</span>
                      </v-col>
                      <v-col class="py-1 pr-2" cols="4">
                        <v-text-field v-model.trim="$v.invitations.$each[i].name.$model" :error="$v.invitations.$each[i].name.$error" hide-details background-color="white" outlined single-line dense />
                      </v-col>
                      <v-list-item-action>
                        <v-btn class="mt-n1" v-if="i >= 1 || invitations.length > 1" @click="invitations.splice(i, 1)" icon color="red" :ripple="false"><v-icon small>mdi-close</v-icon></v-btn>
                      </v-list-item-action>
                    </v-row>
                    <v-row no-gutters>
                      <v-col class="pa-0">
                        <v-btn @click.prevent="addRowInvitations" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar otro</v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-subtitle>
                </v-col>
                </v-list-item>
              </v-list>
          </v-col>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogCreate=false" outlined>Cancelar</v-btn>
          <v-btn @click="postInvitations" :loading="createLoader" color="primary">Enviar invitaciones</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog invitations -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, email, maxLength } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import cloneDeep from 'lodash/cloneDeep'
export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    invitations: [
      { email: '', name: '' },
      { email: '', name: '' }
    ],
    dialogCreate: false,
    createLoader: false
  }),
  computed: mapState({
    membersList: state => cloneDeep(state.accounts.membersList),
    invitationsList: state => state.accounts.invitationsList
  }),
  created () {
    this.$store.dispatch('accounts/LIST', {
      resource: 'members'
    })
    .then(() => {
      this.$store.dispatch('accounts/LIST', {
        resource: 'invitations',
        query: {
          accepted: 'False'
        }
      })
    })
    .catch((error) => {
      this.$dialog.message.error(error.response.data.detail)
    })
  },
  watch: {
    dialogCreate () {
      if (this.dialogCreate) {
        return false
      }
      this.$v.invitations.$reset()
      this.invitations = [
        { email: '', name: '' },
        { email: '', name: '' }
      ]
    }
  },
  methods: {
    postInvitations () {
      this.$v.invitations.$touch()
      if (this.$v.invitations.$invalid) {
        return false
      }
      this.createLoader = true
      this.$store.dispatch('accounts/BULK_INVITATION', {
        persons: this.invitations
      })
      .then(() => {
        this.dialogCreate = false
        this.$store.dispatch('accounts/LIST', {
          resource: 'invitations',
          query: {
            accepted: 'False'
          }
        })
        this.$dialog.message.info('Las invitaciones han sido enviadas')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.createLoader = false
      })
    },
    patchMember (i) {
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'members',
        payload: {
          is_admin: !this.membersList[i].is_admin
        },
        id: this.membersList[i].id
      })
      .then((response) => {
        this.$store.dispatch('accounts/LIST', {
          resource: 'members',
          loader: false
        })
        this.$dialog.message.info('El tipo de cuenta del miembro se ha actualizado')
      })
      .catch((error) => {
        this.$dialog.message.error(error.response.data.detail)
      })
    },
    deleteMember (i) {
      this.$dialog.warning({
        title: `${this.membersList[i].is_active ? 'Desactivar' : 'Activar'} usuario`,
        text: `
          <span class="d-block mb-4">¿Qué ocurre cuando se ${this.membersList[i].is_active ? 'desactiva' : 'activa'} un usuario?</span>
          <span class="d-block pl-6">1. El miembro ${this.membersList[i].is_active ? 'ya no' : ''} podrá trabajar en el espacio de trabajo.</span>
          <span class="d-block pl-6">2. Toda la información creada por el miembro seguirá estando disponible.</span>
        `,
        actions: [
          {
            text: 'Continuar',
            color: this.membersList[i].is_active ? 'red' : 'primary',
            handle: () => {
              this.$store.dispatch('accounts/UPDATE', {
                resource: 'members',
                payload: {
                  is_active: !this.membersList[i].is_active
                },
                id: this.membersList[i].id
              })
              .then((response) => {
                this.$store.dispatch('accounts/LIST', {
                  resource: 'members',
                  loader: false
                })
                this.$dialog.message.info(`El miembro ha sido ${this.membersList[i].is_active ? 'desactivado' : 'activado'} en la organización`)
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    deleteInvitation (i) {
      this.$dialog.warning({
        title: 'Eliminar invitación',
        text: `
          <span class="d-block mt-4">${this.invitationsList[i].email} no podrá unirse a ${this.account.name}.</span>
          <span class="d-block mb-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer.</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
             this.$store.dispatch('accounts/DESTROY', {
                resource: 'invitations',
                id: this.invitationsList[i].id
              })
              .then((response) => {
                this.$dialog.message.info('La invitación ha sido eliminada')
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data.detail))
              })
            }
          }
        ]
      })
    },
    addRowInvitations () {
      this.invitations.push({
        email: '',
        name: ''
      })
    }
  },
  validations: {
    invitations: {
      $each: {
        email: {
          required,
          email,
          maxLength: maxLength(254),
          isUser: function (value) {
            return !this.membersList.filter(member => member.email === value).length
          },
          isInvited: function (value) {
            return !this.invitationsList.filter(invitation => invitation.email === value).length
          }
        },
        name: {
          required,
          maxLength: maxLength(32)
        }
      }
    }
  }
}
</script>